<template>
  <div :class="['op--modal-container', {hide:!show}]" @click="close">
    <div class="op--modal">

      <div class="op--modal-content">
        <div class="shared-box" @click.stop>
          <div class="sb-title">{{ $t('serviceSelect.tryService2', {service: targetService}) }}</div>
          <div class="sb-body">
            <p>
              <span v-if="allowTime.start !== allowTime.end">
                {{
                  $t('serviceSelect.serviceAirportAvailable1', {
                    service: sharedLabel,
                    start: allowTime.start,
                    end: allowTime.end,
                  })
                }}
              </span>
              <span v-else>
                {{ $t('serviceSelect.serviceAirportAvailable2', {service: sharedLabel}) }}
              </span>
            </p>
            <p v-show="!!service">{{ $t('serviceSelect.wouldYouLike', {service: targetService}) }}</p>

            <span class="loaderx"><i class="fa fa-spinner fa-spin" v-show="serviceLoading"></i></span>
            <span class="op-btn btn-success btn-block btn-md margin-t-l"
              @click="selectNextService" v-show="!!service">
              {{ $t('serviceSelect.yesChoose', {service: targetService}) }}
            </span>
            <span class="op-btn btn-block btn-md margin-t-s" @click="close">{{ $t('common.cancel') }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { isValidNumber } from 'libphonenumber-js'
import ApiPickupType from '@/modules/api/pickup-type'

export default {
  name: 'shared-alloted-time-modal',
  props: ['leg', 'service', 'code'],
  data () {
    return {
      show: false,
      targetService: ''
    }
  },
  computed: {
    sharedLabel () {
      let services = this.$store.state.reservation.leg1.services
      if (!services.shared || !services.shared.brandedName) {
        return 'Shared'
      } else {
        return services.shared.brandedName
      }
    },
    allowTime () { return this.$store.state.reservation.sharedAllowedTime },
    serviceLoading () { return this.$store.state.reservation.serviceLoading }
  },
  methods: {
    close () {
      this.show = false
      document.body.classList.remove('widget-no-scroll')
    },
    showModal () {
      this.show = true
      document.body.classList.remove('widget-no-scroll')
      document.body.classList.add('widget-no-scroll')
    },
    selectNextService () {
      this.close()
      this.$store.commit('reservation/setSelectedService', {
        leg: this.leg,
        value: this.code
      })
      if (this.leg === 'leg1') {
        this.$store.commit('reservation/setSelectedService', {
          leg: 'leg2',
          value: this.code
        })
      }
      this.updatePickupType()
    },
    changeDate () {
      this.show = false
      document.body.classList.remove('widget-no-scroll')
      this.$store.commit('reservation/setActiveLeg', this.leg)
      this.$store.commit('reservation/setSharedChangeTime', this.leg)
      this.$store.commit('serviceSelection/showDateTimePicker')
    },
    updatePickupType () {
      let user = this.$store.state.user
      let notInternational = true
      if (user.phone.number) {
        let userPhone = '+' + user.phone.code + user.phone.number
        notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
      }
      ApiPickupType.update(this, {isUS: notInternational}, function () {})
    }
  },
  watch: {
    service: function (value) {
      if (!value) { this.targetService = 'other' }
      this.targetService = value
    },
    show: function (value) {
      let self = this
      self.$nextTick().then(() => {
        self.$forceUpdate()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.shared-box{
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  border-radius: 3px;
  overflow: hidden;
}

.sb-title{
  font-size: 21px;
  text-align: center;
  color: #fff;
  background: #5b5b5b;
  padding: 10px;
}

.sb-body{
  padding: 20px;

  p{
    margin-top: 0;
    color: #777;
    margin-bottom: 5px;
  }
}

.loaderx{
  display: block;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// SharedAllotedTimeModal.vue?5ab0fa3e